import { PdPanelButton } from "./pd-panel-button/PdPanelButton.js";
//#region src/pd-panel-button/pd-panel-button.ts
var tag = "pd-panel-button";
if (!customElements.get(tag)) customElements.define(tag, PdPanelButton);
//#endregion
export { PdPanelButton };
